/* eslint-disable camelcase */
export default {
  autoship: "СТАТУС АВТОДОСТАВКИ",
  yes: "ДА",
  no: "НЕТ",
};
